import { createStore } from 'effector';

export const $requestsList = createStore([]);
$requestsList.watch((state) => console.log('$requestsList', state));
